import {  TextField } from "@material-ui/core"
import { useState } from "react"
import { Typography } from "@material-ui/core"
import { createStyles, makeStyles, Theme } from "@material-ui/core/styles"
import Box from "@material-ui/core/Box";


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      position: "relative",
      "& .MuiTextField-root": {
        "& p": {
          marginLeft: "0px",
          marginTop: "4px",
        },
      },
      "& .MuiInputBase-input": {
        fontSize: 16,
        fontFamily: "Open Sans",
        lineHeight: 1.4,
        "&::placeholder": {
          fontSize: "16px",
          fontFamily: "Open Sans",

          color: "#808080",
          opacity: 1,
        },
      },
      "& .MuiOutlinedInput-multiline": {
        padding: 0,
      },
    },
  })
)

function CustomInput(props: any) {
  const classes = useStyles()
  const [wordCount, setWordcount] = useState(0)
  const {value,...otherProps}=props;
  return (
    <>
      {/* <form className={classes.root} noValidate autoComplete="on"> */}
      <div className={classes.root}>
        <TextField
          classes={
            {
              // root: "classes-root", // class name, e.g. `root-x`
              // disabled: "classes-disabled", // class name, e.g. `disabled-x`
              // label:"classes-formControl"
            }
          }
          className="h4"
          fullWidth
          margin="8px"
          onChange={(e: any) => {
            typeof props.setError === "function" && props.setError()
            var dataIndex = props.dataIndex == undefined ? 0 : props.dataIndex
            props?.multiline &&
              setWordcount(e.target.value.match(/\w+/g)?.length)
            props.parentcall &&
              props.parentcall(e.target.value, props.id, dataIndex)
              props.AdditionalSection && 
              props.AdditionalSection(e.target.value)
          }}
          onFocus={() => {
            props?.multiline &&
              setWordcount(props?.defaultValue?.match(/\w+/g)?.length)
          }}
          autoComplete="none"
          value={value!=="null"?value:""}
          {...otherProps}
        />
        {wordCount > 0 && (
          <Box
            bgcolor="#232323"
            color="#fff"
            py="3px"
            px="10px"
            textAlign="center"
            position="absolute"
            borderRadius={50}
            bottom={5}
            right={5}
          >
            <Typography>{wordCount}</Typography>
          </Box>
        )}
      </div>
      {/* </form> */}
    </>
  )
}

export default CustomInput
